export const SHETAB = 'Shetab';
export const SHAPARAK = 'Shaparak';
export const CARD_TO_CARD = 'Card to Card';
export const CRYPTO = 'Crypto';
export const UVOCUHER = 'Uvocuher';

export const PHONE_NUMBER_REGEXP = /^254[0-9]{9}$/;
export const PHONE_NUMBER_WITHOUT_CODE_REGEXP = /^[0-9]{10}$/;
export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const ACCOUNT_NUMBER_LENGTH = 11;
export const AMOUNT_FIELD_NAME = 'amount';

export const TYPE_DROPDOWN = 'dropdown';

export const DEPOSIT_CONFIG = {
  [SHETAB]: {
    [AMOUNT_FIELD_NAME]: {},
  },
  [SHAPARAK]: {
    [AMOUNT_FIELD_NAME]: {},
  },
  [CARD_TO_CARD]: {
    [AMOUNT_FIELD_NAME]: {},
  },
  [CRYPTO]: {
    [AMOUNT_FIELD_NAME]: {},
  },
  [UVOCUHER]: {
    [AMOUNT_FIELD_NAME]: {},
  },
};

export const WITHDRAW_CONFIG = {
  [SHETAB]: {
    [AMOUNT_FIELD_NAME]: {},
    account_number: {},
  },
  [SHAPARAK]: {
    [AMOUNT_FIELD_NAME]: {},
    account_number: {},
  },
  [CARD_TO_CARD]: {
    [AMOUNT_FIELD_NAME]: {},
    account_number: {},
  },
  [CRYPTO]: {
    [AMOUNT_FIELD_NAME]: {},
    account_number: {},
  },
  [UVOCUHER]: {
    [AMOUNT_FIELD_NAME]: {},
    account_number: {},
  },
};
